import cn from 'clsx'

type Props = {
  className?: string
}

export default function TryDemoButton({ className }: Props) {
  return (
    <form action='/api/demo-sessions' method='post' className={className}>
      <button type='submit' className={cn('btn btn-outline', className)}>
        View sandbox
      </button>
    </form>
  )
}
